// Models
import { FixedDate } from "./FixedDate";
/**
 * Represents a yearly fixed date.
 * @example 14th of February.
 */ export class YearlyFixedDate extends FixedDate {
    getMonthForPeriod(_) {
        return this.month;
    }
    /**
     * Constructs a new YearlyFixedDate instance.
     *
     * @param month - The month of the date (1-based, e.g., 2 for February).
     * @param dayOfMonth - The day of the month (e.g., 14 for the 14th day).
     */ constructor(month, dayOfMonth){
        super(dayOfMonth), this.month = month;
    }
}
